import { EnumBase } from 'hay-core-react';

/**
 * PublicacaoModeloiaEnum — modelos Claude disponíveis pra "Avaliação por IA" (ver
 * Publicacao.modeloia no backend). Valores são os IDs reais de modelo da API Anthropic (não
 * chaves i18n como os demais enums desta pasta) — mesma lista de `IaPrecoService.PRECOS_POR_MILHAO`
 * no backend; qualquer mudança aqui precisa espelhar lá também.
 */
class PublicacaoModeloiaEnum extends EnumBase {
  constructor() {
    super(
      [
        'claude-haiku-4-5',
        'claude-sonnet-4-6',
        'claude-sonnet-5',
        'claude-opus-5',
      ],
      'claude-sonnet-4-6'
    );
  }
}

export default new PublicacaoModeloiaEnum();
